import axiosInstance from "../../../../config/apiConfig"; 
import { useQuery } from "@tanstack/react-query";

export const getReportDetails = async (reportId) => {
  if (!reportId) return null; 

  try {
    const { data } = await axiosInstance.get(`/reports/${reportId}`);
    return data || null; 
  } catch (error) {
    console.error(`Error fetching report details for ID ${reportId}:`, error);
    return null;
  }
};

const useReportDetails = (reportId) => {
  return useQuery({
    queryKey: ["reportDetails", reportId], 
    queryFn: () => getReportDetails(reportId),
    enabled: !!reportId, 
  });
};

export default useReportDetails;
